import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduRentalPropertyImage from '@/assets/adu-rental-property.jpg';

const CanYouBuildADUOnRentalPropertyCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/build-adu-rental-property-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduRentalPropertyImage} 
              alt="Landlord discussing ADU plans with tenants" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can You Build an ADU on a Rental Property?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand rules, benefits, and potential legal considerations when building an ADU on rental property in California.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Building an ADU on Rental Properties: Legal Guidelines
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California law permits property owners to build ADUs on rental properties, subject to proper tenant notification and lease agreement compliance. Landlords must follow local permitting processes, respect existing tenant rights, and coordinate construction activities to minimize disruption to current residents while maintaining habitability standards.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Landlord Benefits and Considerations
              </h2>
              <p className="text-white leading-relaxed mb-6">
                ADUs on rental properties provide additional income streams, increased property value, and enhanced investment returns. Landlords can offer multi-generational housing options, attract diverse tenant demographics, and maximize land use efficiency. However, construction requires careful planning around existing tenancies, utility upgrades, and potential temporary displacement considerations.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-specific Rules and Tenant Rights
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Local jurisdictions may require specific tenant notification periods for ADU construction, typically 30-60 days advance notice. Some cities mandate tenant relocation assistance during major construction phases. Rent control ordinances may affect ADU rental rates, and existing leases must be honored throughout the construction process while ensuring tenant safety and habitability.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Can landlords legally build ADUs on rented property?</p>
                  <p>A: Yes, landlords typically can, with tenant coordination and city approval.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Do tenants have rights if the landlord builds an ADU?</p>
                  <p>A: Yes, tenant rights and notice requirements must be respected.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanYouBuildADUOnRentalPropertyCalifornia;